// #798 — admin /admin/services catalog. Mirrors the backend `ServiceDto`
// (libs/back/api/services-api/src/lib/dto/service.dto.ts) and the Prisma
// `Service` model field-for-field. `ServiceKind` is re-declared here (rather
// than imported from `@prisma/client`) since Prisma's generated client isn't
// importable from browser bundles.
export interface ServiceI {
  id: string;
  slug: string;
  name: string;
  longName?: string | null;
  kind: ServiceKindEnum;
  stripeProductId: string;
  isActive: boolean;
  defaultIcon?: string | null;
  prep?: string | null;
  tagline?: string | null;
  sortOrder: number;
  createdAt: Date;
  updatedAt: Date;
  // Live Stripe prices — attached by the admin list endpoint (findAllAdmin)
  // for the "Active price count" table column (#798). Absent on the single-
  // service detail read (findOneAdmin doesn't attach prices).
  prices?: StripePriceI[];
}

export enum ServiceKindEnum {
  HYDROSTATIC = 'HYDROSTATIC',
  VO2MAX = 'VO2MAX',
  RMR = 'RMR',
  OTHER = 'OTHER',
}

export interface StripePriceI {
  id: string;
  type: 'one_time' | 'recurring';
  unitAmount: number;
  currency: string;
  nickname?: string | null;
  recurring?: { interval: string; intervalCount: number } | null;
}

export interface UpcomingEventCountI {
  count: number;
}
